"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _HeaderLogo = _interopRequireDefault(require("../../HeaderLogo"));

var _BurgerButton = _interopRequireDefault(require("../../BurgerButton"));

var _MenuSlider = require("../MenuSlider.style");

var MenuSliderHeader = function MenuSliderHeader(_ref) {
  var homeLink = _ref.homeLink,
      isNavOpen = _ref.isNavOpen,
      setIsNavOpen = _ref.setIsNavOpen,
      toggleNav = _ref.toggleNav,
      variation = _ref.variation;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      header = _ref2.header,
      colors = _ref2.colors;

  var logoProps = {
    color: variation === 'mega' ? colors[header.secondaryLogo.color] : colors[header.logo.color],
    height: header.logo.height,
    width: header.logo.width
  };
  return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderHeader, {
    variation: variation
  }, /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderHeaderWrap, null, /*#__PURE__*/_react.default.createElement(_MenuSlider.LogoWrap, null, /*#__PURE__*/_react.default.createElement(_HeaderLogo.default, Object.assign({
    homeLink: homeLink
  }, logoProps))), /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderBurgerWrap, {
    isNavOpen: isNavOpen,
    variation: variation
  }, /*#__PURE__*/_react.default.createElement(_BurgerButton.default, {
    toggled: isNavOpen,
    toggle: setIsNavOpen,
    onClick: toggleNav
  }))));
};

MenuSliderHeader.propTypes = {
  homeLink: _propTypes.default.string,
  isNavOpen: _propTypes.default.bool.isRequired,
  setIsNavOpen: _propTypes.default.func.isRequired,
  toggleNav: _propTypes.default.func.isRequired,
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
MenuSliderHeader.defaultProps = {
  homeLink: '/',
  variation: 'mega'
};
var _default = MenuSliderHeader;
exports.default = _default;